// API Routes constants - based on backend specification
export const API_ROUTES = {
  // Auth routes - all under /api/auth/ prefix
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    GET_CURRENT_USER: '/api/auth/users/me',
    CHANGE_ORGANIZATION: '/api/auth/change-organization',
    FORGOT_PASSWORD: '/api/auth/forget-password/',
    RESET_PASSWORD: '/api/auth/reset-password/',
    SSO_REDIRECT: '/api/auth/dipo_sso_redirect',
  },
  
  // File upload routes - all under /api/files/ prefix
  FILES: {
    UPLOAD: '/api/files/upload',
    LIST: '/api/files/',
    GET_BY_ID: (id) => `/api/files/${id}`,
    DELETE: (id) => `/api/files/${id}`,
    MOVE_TO_STORAGE: (id) => `/api/files/${id}/move-to-storage`,
    GET_CONTENT: (id) => `/api/files/${id}/content`,
    DOWNLOAD: (id) => `/api/files/${id}/download`,
    MEDIA_INFO: (id) => `/api/files/${id}/media-info`,
    UPDATE_STATUS: (id) => `/api/files/${id}/status`,
  },
  
  // Transcript routes
  TRANSCRIPTS: {
    LIST: '/api/transcripts',
    CREATE: '/api/transcripts',
    GET_BY_ID: (id) => `/api/transcripts/${id}`,
    UPDATE: (id) => `/api/transcripts/${id}`,
    DELETE: (id) => `/api/transcripts/${id}`,
    UPLOAD: '/api/transcripts/upload',
  },
  
  // Session routes
  SESSIONS: {
    LIST: '/api/reports/sessions/',
    CREATE: '/api/reports/sessions/',
    GET_BY_ID: (id) => `/api/reports/sessions/${id}`,
    GET_BY_EVENT: (eventId) => `/api/reports/sessions/?event_id=${eventId}`,
    UPDATE: (id) => `/api/reports/sessions/${id}`,
    DELETE: (id) => `/api/reports/sessions/${id}`,
    START_TRANSCRIPT: (id) => `/api/reports/sessions/${id}/start-transcript`,
    REGENERATE_TRANSCRIPT: (id) => `/api/reports/sessions/${id}/regenerate-transcript`,
    QUEUE_STATUS: (id) => `/api/reports/sessions/${id}/queue-status`,
    CHUNK_PROGRESS: (id) => `/api/reports/sessions/${id}/chunk-progress`,
    REPORT_STATUS: (id) => `/api/reports/sessions/${id}/report/status`,
  },
  
  // Report routes
  REPORTS: {
    REGENERATE_REPORT: (id) => `/api/reports/sessions/${id}/regenerate-report`,
    SESSION_STATUS: (id) => `/api/reports/sessions/${id}/report/status`,
    EVENT_STATUS: (id) => `/api/reports/events/${id}/report/status`,
  },
  
  // Event routes
  EVENTS: {
    LIST: '/api/reports/events/',
    CREATE: '/api/reports/events/',
    GET_BY_ID: (id) => `/api/reports/events/${id}`,
    GET_WITH_SESSIONS: (id) => `/api/reports/events/${id}/with-sessions`,
    UPDATE: (id) => `/api/reports/events/${id}`,
    DELETE: (id) => `/api/reports/events/${id}`,
    // Event report routes
    GENERATE_REPORT: (id) => `/api/reports/events/${id}/generate-report`,
    REPORT: (id) => `/api/reports/events/${id}/report`,
    REPORT_STATUS: (id) => `/api/reports/events/${id}/report/status`,
    SEND_WORDPRESS: (id) => `/api/reports/events/${id}/send-wordpress`,
  },
  
  // User routes
  USERS: {
    PROFILE: '/api/users/profile',
    UPDATE: '/api/users/profile',
  },
  
  // Chatbot routes (ako ih ima)
  CHATBOT: {
    GET_BY_PUB_KEY: '/api/chatbot/public-key',
  },
};

// Export individual routes for backward compatibility
export const {
  AUTH,
  FILES,
  TRANSCRIPTS,
  SESSIONS,
  EVENTS,
  USERS,
  CHATBOT,
} = API_ROUTES;
